import { render, staticRenderFns } from "./UploadDocumento.vue?vue&type=template&id=297046f0&scoped=true"
import script from "./UploadDocumento.vue?vue&type=script&lang=ts"
export * from "./UploadDocumento.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumento.vue?vue&type=style&index=0&id=297046f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297046f0",
  null
  
)

export default component.exports